import { Icon } from '@startlibs/components';
import { getColor } from '@startlibs/utils';
import { transparentize } from 'polished';
import React from 'react'
import styled from 'styled-components/macro'

const Highlight = styled.div`
  border-radius: 30rem;
  width: 36rem;
  height: 36rem;
  padding: 6rem 6rem 7rem 6rem;
  color: white;
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  background: ${props => transparentize(0.15, getColor("main")(props))};
  display: flex;
  align-items: center;
  justify-content: center;
  animation: scale-in-center 0.25s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  ${Icon} {
    font-size: 140px;
  }
  @keyframes scale-in-center {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`

export const DropModal = styled(({children,...props}) =>
  <div {...props}>
    <Highlight>
      <div>
        <Icon icon="upload"/>
        <div>Drop studies here to upload them</div>
      </div>
    </Highlight>
  </div>
)` 
  pointer-events: none;
  position: fixed;
  top: 0;
  bottom: 0;
  right:0;
  left:0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => transparentize(0.7, getColor("main")(props))};
  z-index: 10000;
  animation: fade-in 0.25s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`